<div class="flex items-center justify-between w-full mt-6 px-2 py-4 border-t border-slate-100 dark:border-slate-700/50">
  <!-- Info Section -->
  <div class="hidden sm:block">
    <p class="text-[10px] font-bold text-slate-400 uppercase tracking-[0.15em]">
      Showing <span class="text-slate-900 dark:text-white">{{ (Number(currentPage) - 1) * itemsPerPage + 1 }}</span> to
      <span class="text-slate-900 dark:text-white">{{ Math.min(Number(currentPage) * itemsPerPage, totalItems) }}</span>
      of <span class="text-slate-900 dark:text-white">{{ totalItems }}</span> Records
    </p>
  </div>

  <!-- Pagination Controls -->
  <div class="flex items-center gap-2">
    <!-- Previous Button -->
    <button [disabled]="Number(currentPage) === 1" (click)="previousPage()"
      class="flex items-center gap-1.5 px-3 py-2 text-[10px] font-bold uppercase tracking-widest text-slate-600 dark:text-slate-400 bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-lg hover:border-primary-800 hover:text-primary-800 dark:text-primary-400 disabled:opacity-30 disabled:cursor-not-allowed disabled:hover:border-slate-200 dark:border-slate-700 disabled:hover:text-slate-600 dark:text-slate-400 transition-all duration-300">
      <svg xmlns="http://www.w3.org/2000/svg" class="w-3.5 h-3.5" viewBox="0 0 24 24" fill="none" stroke="currentColor"
        stroke-width="3" stroke-linecap="round" stroke-linejoin="round">
        <path d="m15 18-6-6 6-6" />
      </svg>
      <span>Prev</span>
    </button>

    <!-- Page Numbers -->
    <div class="flex items-center gap-1.5 mx-2">
      @for (page of pages; track $index) {
      @if (page === '...') {
      <span class="w-8 h-8 flex items-center justify-center text-slate-300 text-xs font-bold">...</span>
      } @else {
      <button (click)="onPageChange(page)"
        class="w-9 h-9 flex items-center justify-center text-[11px] font-bold rounded-lg transition-all duration-300 relative group"
        [class.bg-primary-800]="page === Number(currentPage)" [class.text-white]="page === Number(currentPage)"
        [class.shadow-[0_8px_16px_-4px_rgba(13,118,186,0.3)]]="page === Number(currentPage)"
        [class.text-slate-600]="page !== Number(currentPage)" [class.hover:bg-primary-50]="page !== Number(currentPage)"
        [class.hover:text-primary-800]="page !== Number(currentPage)" [class.border]="page !== Number(currentPage)"
        [class.border-transparent]="page !== Number(currentPage)"
        [class.hover:border-primary-100]="page !== Number(currentPage)">
        {{ page }}

        <!-- Subtle dot for active page -->
        @if (page === Number(currentPage)) {
        <span class="absolute -bottom-1 left-1/2 -translate-x-1/2 w-1 h-1 bg-white dark:bg-slate-800 rounded-full opacity-50"></span>
        }
      </button>
      }
      }
    </div>

    <!-- Next Button -->
    <button [disabled]="Number(currentPage) === totalPages" (click)="nextPage()"
      class="flex items-center gap-1.5 px-3 py-2 text-[10px] font-bold uppercase tracking-widest text-slate-600 dark:text-slate-400 bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-lg hover:border-primary-800 hover:text-primary-800 dark:text-primary-400 disabled:opacity-30 disabled:cursor-not-allowed disabled:hover:border-slate-200 dark:border-slate-700 disabled:hover:text-slate-600 dark:text-slate-400 transition-all duration-300">
      <span>Next</span>
      <svg xmlns="http://www.w3.org/2000/svg" class="w-3.5 h-3.5" viewBox="0 0 24 24" fill="none" stroke="currentColor"
        stroke-width="3" stroke-linecap="round" stroke-linejoin="round">
        <path d="m9 18 6-6-6-6" />
      </svg>
    </button>
  </div>
</div>